import { ACCOUNTLINKING_API } from '~/lib/constants';

export function getApiPath(profile: string, path: string): string {
  return `${ACCOUNTLINKING_API}/${profile}/v1/${path}`;
}
